const ComponentsLookup = {
  "default-footer": "DefaultFooterEa219d1c3bd84ae7A528C11534f1c415"
}

export default ComponentsLookup;